import React from "react";
import { Tooltip } from "@mui/material";
/**
 * Cell for easier display of long text values.
 */
export const LimitedCell = ({ cell, maxCharShown, isLink = false, }) => {
    const cellText = cell.getValue();
    return (React.createElement("div", { className: "flex gap-2 min-w-0 max-w-[50ch]" }, cellText.length > maxCharShown ? (React.createElement(Tooltip, { title: cellText, slotProps: {
            tooltip: {
                className: "!text-sm !max-w-md",
            },
        } }, isLink ? (React.createElement("a", { href: cell.row.original.file_url }, cellText.slice(0, maxCharShown).toLocaleString() + " [...]")) : (React.createElement("span", { className: "break-words w-full" }, cellText.slice(0, maxCharShown).toLocaleString() + " [...]")))) : isLink ? (React.createElement("a", { href: cell.row.original.file_url }, cellText)) : (React.createElement("span", null, cellText))));
};
